<template>
    <div class="o-table-wrapper">
        <div class="o-table-responsive">
            <table class="o-table-core">
                <slot></slot>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OTable',
}
</script>

<style scoped>
/* Container Table - Menghilangkan padding card agar bisa full-width jika perlu */
.o-table-wrapper {
    width: 100%;
    background: #ffffff;
    border-radius: 12px;
    /* overflow: hidden; */
}

.o-table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

/* Base Table Styling */
.o-table-core {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin: 0;
}

/* Header Styling (Menggunakan :deep agar masuk ke slot) */
.o-table-core :deep(thead) {
    background-color: #f8fafc;
    border-bottom: 2px solid #f1f5f9;
}

    .o-table-core :deep(thead) tr th,
    .o-table-core :deep(thead) tr td {
        padding: 14px 8px;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        font-weight: bold;
        flex: 1 1 0%;
        /* display: flex; */
        box-sizing: border-box;
        min-height: 45px;
        padding-top: 8px;
        padding-bottom: 8px;
        -moz-box-align: center;
        align-items: center;
        background: var(--secondary-color, rgba(242, 113, 120, 0.09)) none repeat scroll 0% 0%;
        /* border-color: currentcolor rgb(219, 214, 225) rgb(219, 214, 225); */
        border-style: none solid solid;
        border-width: medium 1px 1px;
        border-image: none 100% / 1 / 0 stretch;
        border-radius: 4px 4px 0px 0px;
        margin: 0px -1px -1px;
    }
    .table > tbody{
        overflow: hidden;
        max-width: 100%;
        text-overflow: ellipsis;
        font-size: 14px;
        letter-spacing: 0.05em;
        color: #64748b;
        text-align: left;
        white-space: nowrap;
    }

    /* Body Styling */
    .o-table-core :deep(tbody) tr {
        border-bottom: 1px solid #f1f5f9;
        transition: all 0.2s ease;
    }

    .o-table-core :deep(tbody) tr:last-child {
        border-bottom: none;
    }

    .o-table-core :deep(tbody) tr:hover {
        background-color: #f8fafc;
    }

    .o-table-core :deep(tbody) tr td {
        padding: 16px 8px;
        font-size: 13px;
        color: #334155;
        vertical-align: middle;
        text-align: left;
    }

    /* Ensure first and last columns have proper outer padding for elite look */
    .o-table-core :deep(tr th:first-child),
    .o-table-core :deep(tr td:first-child) {
        padding-left: 24px;
    }

    .o-table-core :deep(tr th:last-child),
    .o-table-core :deep(tr td:last-child) {
        padding-right: 24px;
    }

/* Custom alignment overrides (useful if passed via props/classes) */
.o-table-core :deep(.text-right) { text-align: right; }
.o-table-core :deep(.text-center) { text-align: center; }

/* Responsive adjustments */
@media (max-width: 768px) {
    .o-table-core :deep(thead) tr th,
    .o-table-core :deep(thead) tr td,
    .o-table-core :deep(tbody) tr td {
        padding: 12px 15px;
    }
}
</style>